import './animation.css';
import Loader from './Loader';

export const Loading = () => {
  return (
    <div className='absolute inset-0 flex flex-col items-center justify-center'>
      <Loader />
    </div>
  );
};
